const headers = {
  name: "General",
  navigate: {
    path: [
      {
        name: "Settings",
        path: "/app/settings",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
